/* th-angebot-fenster.js · Angebots-Fenster A (Fassung 09.10.2026, Postfach-Weg 13.10.2026)
   Geladen über snippets/th-angebot-fenster.liquid. Die Section th-pdp-galerie bleibt unverändert:
   Dieses Script übernimmt die 2 Knöpfe „Angebot erstellen (PDF)“ und „Angebot per E-Mail“.
   13.10.2026: Ohne Server (endpunkt leer). Jedes Angebot, auch das PDF, geht über das
   Kontaktformular an hello@ – mit Datenblock #TH-ANGEBOT# für den Bestell-Entwurf.
   14.10.2026 (Angebot-Fix): Kein Versand im Hintergrund mehr (Shopify fing ihn mit der
   Roboter-Prüfung ab). Das echte Kontaktformular aus snippets/th-angebot-fenster.liquid wird
   normal abgesendet; Shopify zeigt bei Bedarf seine Prüfseite. Erfolg erst, wenn die Seite
   mit contact_posted=true bzw. form.posted_successfully? zurückkommt. Das PDF entsteht vorher. */
(function(){
    var plusEl = document.querySelector('[data-th-angebot-plus]');
    var root = (plusEl && plusEl.closest && plusEl.closest('[data-th-konfigurator]')) || document.querySelector('[data-th-konfigurator]');
    if(!root) return;
    var btn = root.querySelector('[data-th-angebot-btn]');
    var out = document.getElementById('th-angebot-print');
    var cfgEl = root.querySelector('[data-th-angebot-cfg]');
    if(!btn || !out || !cfgEl) return;
    var cfg; try{ cfg = JSON.parse(cfgEl.textContent); }catch(e){ return; }
    /* Zusatz-Angaben aus dem Baustein (Firma mit GmbH, Artikelart, Abholung/Zahlung, Adresse der Mini-App) */
    var plus = {}; try{ if(plusEl){ plus = JSON.parse(plusEl.textContent) || {}; } }catch(e){ plus = {}; }
    cfg.shop = cfg.shop || {}; cfg.trailer = cfg.trailer || {};
    cfg.istAnhaenger = plus.istAnhaenger !== false;
    cfg.abholung = plus.abholung || '';
    cfg.seite = plus.seite || '';
    cfg.endpunkt = (typeof plus.endpunkt === 'string') ? plus.endpunkt : '/apps/angebot';
    cfg.datenschutz = plus.datenschutz || '/policies/privacy-policy';
    if(plus.firma){ cfg.shop.name = plus.firma; }
    function euro(c){ return (c/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; }
    function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }
    function groupOf(label){
      var el = label.previousElementSibling;
      while(el){
        if(el.classList && (el.classList.contains('th-pdp__addon-grouptitle') || el.classList.contains('th-pdp__konfig-divider'))){
          var t = (el.textContent||'').toLowerCase();
          if(t.indexOf('ausf')>-1) return 'ausf';
          if(t.indexOf('service')>-1) return 'service';
          return 'zub';
        }
        el = el.previousElementSibling;
      }
      return 'zub';
    }
    function thSel(){ var p = root.__thkSel; return (p && !p.cur) ? p : null; }
    function thSpecs(p){ var a=[];
      if(p.len && p.wid) a.push('Nutzmaß '+p.len+' × '+p.wid+' cm');
      if(p.zgg) a.push('zGG '+p.zgg+' kg');
      if(p.nutz) a.push('Nutzlast '+p.nutz+' kg');
      if(p.br) a.push(p.br);
      if(p.mat) a.push(p.mat);
      return a.join(' · '); }
    function thTrailer(){ var t=cfg.trailer, p=thSel(); if(!p) return t;
      return { title: p.title||t.title, kick: t.kick, specs: thSpecs(p)||t.specs, artnr: (p.anr||''),
               img: p.img||t.img, priceCents: p.c||0, zgg: p.zgg||0, leer: p.leer||0, nutz: p.nutz||0 }; }
    function collect(){
      var g = {anh:[], ausf:[], zub:[], service:[]};
      var _t=thTrailer(), _s=thSel();
      g.anh.push({t:_t.title, q:1, u:_t.priceCents, a:_t.artnr, v:((_s&&_s.vid)||cfg.trailer.vid||'')});
      Array.prototype.forEach.call(root.querySelectorAll('[data-th-addon]'), function(l){
        var cb = l.querySelector('[data-th-addon-cb]');
        if(!cb || !cb.checked) return;
        var nameEl = l.querySelector('.th-pdp__addon-name');
        var name = nameEl ? nameEl.textContent.trim() : 'Position';
        var u = parseInt(l.getAttribute('data-addon-price')||'0',10);
        var w = parseInt(l.getAttribute('data-addon-weight')||'0',10);
        var qEl = l.querySelector('[data-th-qty-input]');
        var q = qEl ? Math.max(1, parseInt(qEl.value,10)||1) : 1;
        var grp = l.getAttribute('data-addon-montage') ? 'service' : groupOf(l);
        (g[grp]||g.zub).push({t:name, q:q, u:u, w:w, a:(l.getAttribute('data-addon-artnr')||'').trim(), v:(l.getAttribute('data-addon-variant')||'')});
      });
      return g;
    }
    function rows(list){
      return list.map(function(it){
        return '<tr class="item"><td class="pos">'+esc(it.t)+(it.a?'<div class="tha-tart">Art.-Nr. '+esc(it.a)+'</div>':'')+'</td><td class="qty">'+it.q+'</td>'
          +'<td class="r netto">'+euro(it.u/1.19)+'</td><td class="r brutto">'+euro(it.u)+'</td>'
          +'<td class="r tot">'+euro(it.u*it.q)+'</td></tr>';
      }).join('');
    }
    /* ===== Angebot · Fassung 09.10.2026 (Fenster A, 1 Nummer, Messpunkt) =====
       o.nr     Angebotsnummer (vom Server oder Ausweich-Nummer)
       o.kunde  { vor, nach, tel, mail } für die Zeile „Angebot für“
       o.server Antwort der Mini-App; dann kommen Preise und Summe von dort */
    function cents(s){ var n = Math.round(parseFloat(String(s).replace(',','.'))*100); return isNaN(n) ? 0 : n; }
    function build(o){
      o = o || {};
      var g = collect();
      var groups = [['Anhänger',g.anh],['Ausführung',g.ausf],['Zubehör',g.zub],['Service',g.service]];
      if(!cfg.istAnhaenger){ groups[0][0] = 'Artikel'; }
      var flat = []; groups.forEach(function(gr){ gr[1].forEach(function(it){ flat.push(it); }); });
      var srv = (o.server && o.server.positionen && o.server.positionen.length) ? o.server.positionen : null;
      if(srv && srv.length === flat.length){
        flat.forEach(function(it,i){ it.u = cents(srv[i].einzelpreis); it.q = parseInt(srv[i].menge,10) || it.q; if(srv[i].artikelnummer) it.a = srv[i].artikelnummer; });
      } else if(srv){
        groups = [['Positionen', srv.map(function(p){ return {t:p.titel + (p.variante && p.variante !== 'Default Title' ? ' – ' + p.variante : ''), q:parseInt(p.menge,10)||1, u:cents(p.einzelpreis), a:p.artikelnummer||'', w:0}; })]];
      }
      var body='', brutto=0;
      groups.forEach(function(gr){
        if(!gr[1].length) return;
        body += '<tr class="grp"><td colspan="5">'+gr[0]+'</td></tr>'+rows(gr[1]);
        gr[1].forEach(function(it){ brutto += it.u*it.q; });
      });
      if(srv && o.server.gesamt != null && cents(o.server.gesamt) > 0){ brutto = cents(o.server.gesamt); }
      var netto = brutto/1.19, mwst = brutto-netto;
      // ===== Gewichte & Zuladung =====
      function kg(n){ return (Math.round(n*10)/10).toLocaleString('de-DE',{maximumFractionDigits:1})+' kg'; }
      function wr(l,v,strong,accent){ return '<div style="display:flex;justify-content:space-between;gap:12px;font-size:12.5px;color:'+(accent?'#760093':'#2F3137')+';padding:3px 0;'+(strong?'font-weight:700;border-top:1px solid #E6E8EB;margin-top:4px;padding-top:6px;':'')+'"><span>'+l+'</span><span style="white-space:nowrap;">'+v+'</span></div>'; }
      var _tr = thTrailer();
      var wLeer = _tr.leer||0, zgg = _tr.zgg||0, nutz = _tr.nutz||0;
      var wAddG = 0; flat.forEach(function(it){ if(it.w) wAddG += it.w*it.q; });
      var wAddKg = wAddG/1000, wTotal = wLeer + wAddKg;
      var zuladung = zgg>0 ? (zgg - wTotal) : (nutz>0 ? nutz - wAddKg : 0);
      var weightsHtml = '';
      if(zgg>0 || wLeer>0 || nutz>0){
        weightsHtml = '<div style="margin-top:16px;border:1px solid #E6E8EB;border-radius:10px;padding:12px 16px;max-width:360px;break-inside:avoid;page-break-inside:avoid;">'
          +'<div class="tha-wl">Gewichte &amp; Zuladung</div>'
          + (wLeer? wr('Leergewicht Anhänger', kg(wLeer)) : '')
          + (wAddKg>0? wr('+ Ausstattung / Zubehör', kg(wAddKg)) : '')
          + ((wLeer||wAddKg>0)? wr('Gesamt-Leergewicht', kg(wTotal), true) : '')
          + (zgg>0? wr('Zul. Gesamtgewicht (zGG)', kg(zgg)) : '')
          + ((zgg>0||nutz>0)? wr('Verbleibende Zuladung', kg(zuladung>0?zuladung:0), true, true) : '')
          +'</div>';
      }
      var nr = o.nr || ownNr();
      var gueltig = cfg.gueltig;
      if(o.server && /^\d{4}-\d{2}-\d{2}$/.test(o.server.gueltig_bis||'')){ var _g = o.server.gueltig_bis.split('-'); gueltig = _g[2]+'.'+_g[1]+'.'+_g[0]; }
      var k = o.kunde || null;
      var forHtml = k ? '<div class="tha-for"><span>Angebot für</span><b>'+esc(k.vor+' '+k.nach)+'</b>'+(k.tel?' · Tel. '+esc(k.tel):'')+(k.mail?' · '+esc(k.mail):'')+'</div>' : '';
      var logo = cfg.logo ? '<img class="tha-logo" src="'+esc(cfg.logo)+'" alt="'+esc(cfg.shop.name)+'">' : '<div class="tha-name">'+esc(cfg.shop.name)+'</div>';
      var timg = _tr.img ? '<img class="tha-tph" src="'+esc(_tr.img)+'" alt="">' : '';
      var tart = _tr.artnr ? '<div class="tha-tart">Art.-Nr. '+esc(_tr.artnr)+'</div>' : '';
      out.innerHTML =
        '<div class="tha-sheet">'
        +'<div class="tha-head">'+logo+'<div class="tha-doc"><div class="tha-t">ANGEBOT</div><div class="tha-meta">Nr. <b>'+esc(nr)+'</b><br>Datum <b>'+esc(cfg.datum)+'</b><br>Gültig bis <b>'+esc(gueltig)+'</b></div></div></div>'
        +forHtml
        +'<div class="tha-seclabel">Deine Zusammenstellung</div>'
        +'<div class="tha-trailer">'+timg+'<div class="tha-tinfo"><div class="tha-tkick">'+esc(_tr.kick)+' · '+(cfg.istAnhaenger?'Anhänger':'Zubehör')+'</div><div class="tha-tname">'+esc(_tr.title)+'</div><div class="tha-tspecs">'+esc(_tr.specs)+'</div>'+tart+'</div></div>'
        +'<table class="tha-table"><colgroup><col><col class="c-qty"><col class="c-num"><col class="c-num"><col class="c-tot"></colgroup><thead><tr><th>Position</th><th class="r">Menge</th><th class="r">Einzel netto</th><th class="r">Einzel brutto</th><th class="r">Gesamt brutto</th></tr></thead><tbody>'+body+'</tbody></table>'
        +'<div class="tha-totals"><div class="tha-box"><div class="tha-trow"><span>Zwischensumme netto</span><span>'+euro(netto)+'</span></div><div class="tha-trow"><span>zzgl. 19 % MwSt.</span><span>'+euro(mwst)+'</span></div><div class="tha-trow tha-grand"><span>Gesamtbetrag (brutto)</span><span>'+euro(brutto)+'</span></div></div></div>'
        +weightsHtml
        +'<div class="tha-foot"><div class="tha-contact"><b>'+esc(cfg.shop.name)+'</b>'+esc(cfg.shop.addr)+'<br>Tel. '+esc(cfg.shop.tel)+' · '+esc(cfg.shop.mail)+'<br>'+esc(cfg.shop.web)+'</div><div class="tha-terms">'+(cfg.abholung?'<b>Abholung und Zahlung:</b> '+esc(cfg.abholung)+'<br>':'')+'<b>Hinweis:</b> '+esc(cfg.hinweis)+'</div></div>'
        +'</div>';
      if(out.parentNode !== document.body){ document.body.appendChild(out); }
      return { nr:nr, brutto:brutto, netto:netto, mwst:mwst, groups:groups, trailer:_tr, n:flat.length };
    }

    /* Ausweich-Nummer, wenn der Server nicht antwortet: W-JJMMTT-XXXX
       (ohne 0/O und 1/I, damit sie sich am Telefon gut durchgeben lässt). */
    function ownNr(){
      var d = new Date(), p = function(n){ return (n<10?'0':'')+n; }, abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', x = '';
      for(var i=0;i<4;i++){ x += abc.charAt(Math.floor(Math.random()*abc.length)); }
      return 'W-' + String(d.getFullYear()).slice(2) + p(d.getMonth()+1) + p(d.getDate()) + '-' + x;
    }
    function uuid(){
      try{ if(window.crypto && crypto.randomUUID) return crypto.randomUUID(); }catch(e){}
      var s = ''; for(var i=0;i<32;i++){ s += Math.floor(Math.random()*16).toString(16); }
      return s.slice(0,8)+'-'+s.slice(8,12)+'-'+s.slice(12,16)+'-'+s.slice(16,20)+'-'+s.slice(20);
    }
    /* Messpunkt: ohne Namen, ohne Telefon. Marketing hängt Google Ads daran. */
    function track(name, p){
      try{ window.dataLayer = window.dataLayer || []; var e = {event:name}; for(var k in p){ e[k] = p[k]; } window.dataLayer.push(e); }catch(e1){}
      try{ if(typeof window.gtag === 'function'){ window.gtag('event', name, p); } }catch(e2){}
      try{ if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){ Shopify.analytics.publish(name, p); } }catch(e3){}
    }
    /* Klartext für die Mail an uns (Ausweich-Weg und „Angebot per E-Mail“). */
    function summary(d, k, extra){
      var L = [];
      L.push('ANGEBOT ' + d.nr);
      L.push('Seite: ' + (cfg.trailer.url || location.href));
      L.push('Kunde: ' + k.vor + ' ' + k.nach + ', Tel. ' + k.tel + (k.mail ? ', ' + k.mail : ''));
      L.push('Anruf zum Angebot erlaubt: ' + (k.anruf ? 'ja' : 'nein'));
      if(extra){ L.push(extra); }
      L.push('');
      d.groups.forEach(function(gr){
        if(!gr[1].length) return;
        L.push(gr[0].toUpperCase());
        gr[1].forEach(function(it){
          L.push('  ' + it.q + ' x ' + it.t
            + (it.a ? '  [Art.-Nr. ' + it.a + ']' : '')
            + (it.v ? '  [Variante ' + it.v + ']' : '')
            + '  ' + euro(it.u) + ' /Stk  =  ' + euro(it.u * it.q));
        });
        L.push('');
      });
      L.push('Zwischensumme netto : ' + euro(d.netto));
      L.push('zzgl. 19 % MwSt.    : ' + euro(d.mwst));
      L.push('GESAMT BRUTTO       : ' + euro(d.brutto));
      L.push('');
      L.push(datenblock(d));
      return L.join('\n');
    }
    /* Maschinenlesbare Zeile für den Bestell-Entwurf (fest, Fassung 14.10.2026):
       #TH-ANGEBOT# Nummer | Varianten-ID x Menge @ Einzelpreis ; ... | GESAMT Summe #ENDE#
       Preise brutto in Euro mit Punkt (z. B. 1334.00). Positionen ohne Varianten-ID
       (z. B. Montage) stehen nur im Klartext oben, zählen aber in GESAMT. */
    function preis(c){ return (Math.round(c) / 100).toFixed(2); }
    function datenblock(d){
      var p = [];
      d.groups.forEach(function(gr){
        gr[1].forEach(function(it){
          var v = String(it.v == null ? '' : it.v).trim();
          if(/^[0-9]{6,20}$/.test(v)){ p.push(v + ' x ' + (it.q || 1) + ' @ ' + preis(it.u || 0)); }
        });
      });
      return '#TH-ANGEBOT# ' + d.nr + ' | ' + p.join(' ; ') + ' | GESAMT ' + preis(d.brutto) + ' #ENDE#';
    }
    /* Versand: echtes Shopify-Kontaktformular (snippets/th-angebot-fenster.liquid), normal
       abgesendet. requestSubmit löst das Absende-Ereignis aus, damit Shopifys Roboter-Prüfung
       mitläuft; ohne requestSubmit (alte Browser) normales submit, Shopify zeigt dann seine
       Prüfseite. Ohne E-Mail des Kunden (nur PDF) steht unsere Adresse im Pflichtfeld. */
    var ctForm = document.querySelector('[data-th-ang-contact]');
    var ctErg = document.querySelector('[data-th-ang-ergebnis]');
    var ctState = ctErg ? (ctErg.getAttribute('data-th-ang-ergebnis') || '') : '';
    var MERK = 'thAngebotOffen';
    function merke(p){ try{ sessionStorage.setItem(MERK, JSON.stringify(p)); return true; }catch(e){ return false; } }
    function gemerkt(){ try{ var s = sessionStorage.getItem(MERK); return s ? JSON.parse(s) : null; }catch(e){ return null; } }
    function vergiss(){ try{ sessionStorage.removeItem(MERK); }catch(e){} }
    function fillForm(d, k, extra, mode){
      if(!ctForm){ return false; }
      var set = function(n,v){ var i = ctForm.querySelector('[name="contact['+n+']"]'); if(i){ i.value = v; } };
      var mail = k.mail || cfg.shop.mail || 'hello@trailer-hunter.com';
      set('name', k.vor + ' ' + k.nach); set('email', mail); set('phone', k.tel);
      set('Angebotsnummer', d.nr); set('Art', mode === 'email' ? 'Angebot per E-Mail' : 'Angebot als PDF');
      set('body', summary(d, k, extra + (k.mail ? '' : ' Kunde hat keine E-Mail angegeben.')));
      return true;
    }
    function absenden(){
      if(!ctForm){ return false; }
      try{
        if(typeof ctForm.requestSubmit === 'function'){ ctForm.requestSubmit(); }
        else { ctForm.submit(); }
        return true;
      }catch(e){
        try{ ctForm.submit(); return true; }catch(e2){ return false; }
      }
    }
    /* Anfrage an die Mini-App. Antwortet sie nicht in 6 Sekunden oder mit einem
       Fehler, geht es mit der Ausweich-Nummer weiter: kein Kunde bleibt hängen. */
    function askServer(payload){
      if(!window.fetch || !cfg.endpunkt){ return Promise.resolve({weg:'ausweich'}); }
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      var timer = setTimeout(function(){ if(ctrl){ ctrl.abort(); } }, 6000);
      return fetch(cfg.endpunkt || '/apps/angebot', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
        .then(function(r){ return r.json().then(function(j){ return {s:r.status, j:j}; }, function(){ return {s:r.status, j:null}; }); })
        .then(function(x){
          clearTimeout(timer);
          var j = x.j;
          if(x.s === 200 && j && j.ok === true && j.angebotsnummer){ return {weg:'server', j:j}; }
          if(x.s === 400 && j && j.fehler === 'eingabe'){ return {weg:'eingabe', feld:j.feld, meldung:j.meldung}; }
          if(x.s === 400 && j && j.fehler === 'artikel'){ return {weg:'artikel'}; }
          return {weg:'ausweich'};
        })
        .catch(function(){ clearTimeout(timer); return {weg:'ausweich'}; });
    }

    /* ----- Fenster A: kleines Fenster, am Handy von unten ----- */
    var mailBtn = root.querySelector('[data-th-mail-btn]');
    var win = null, st = {mode:null, opener:null, t0:0, id:'', busy:false};
    var FELD = {vorname:'vor', nachname:'nach', telefon:'tel', email:'mail'};
    function el(id){ return document.getElementById('th-ang-'+id); }
    function fieldHtml(id, label, type, ac, extra){
      return '<div class="th-ang__f"><label for="th-ang-'+id+'">'+label+' <i data-opt-'+id+' hidden>(freiwillig)</i></label>'
        +'<input id="th-ang-'+id+'" name="'+id+'" type="'+type+'" autocomplete="'+ac+'" aria-describedby="th-ang-'+id+'-m"'+(extra||'')+'>'
        +'<p class="th-ang__msg" id="th-ang-'+id+'-m" hidden></p></div>';
    }
    function ensureWin(){
      if(win){ return win; }
      win = document.createElement('div');
      win.className = 'th-ang'; win.hidden = true;
      win.innerHTML = '<div class="th-ang__win" role="dialog" aria-modal="true" aria-labelledby="th-ang-t" aria-describedby="th-ang-s">'
        +'<div class="th-ang__top"><div><h2 class="th-ang__h" id="th-ang-t"></h2><p class="th-ang__sub" id="th-ang-s">Für wen ist das Angebot? Mit deinem Namen finden wir es wieder, wenn du anrufst.</p></div>'
        +'<button type="button" class="th-ang__x" id="th-ang-x" aria-label="Fenster schließen">×</button></div>'
        +'<div class="th-ang__recap"><span id="th-ang-rn"></span><b id="th-ang-rs"></b></div>'
        +'<form class="th-ang__form" id="th-ang-form" novalidate>'
        +'<div class="th-ang__grid">'+fieldHtml('vor','Vorname','text','given-name',' maxlength="60" required aria-required="true"')+fieldHtml('nach','Nachname','text','family-name',' maxlength="60" required aria-required="true"')+'</div>'
        +'<div class="th-ang__grid">'+fieldHtml('tel','Telefon','tel','tel',' inputmode="tel" maxlength="25" required aria-required="true"')+fieldHtml('mail','E-Mail','email','email',' maxlength="254"')+'</div>'
        +'<div class="th-ang__hp" aria-hidden="true"><label for="th-ang-website">Website</label><input id="th-ang-website" name="website" type="text" tabindex="-1" autocomplete="off"></div>'
        +'<label class="th-ang__check" for="th-ang-anruf"><input type="checkbox" id="th-ang-anruf" name="anruf"><span>Ihr dürft mich zum Angebot anrufen.</span></label>'
        +'<p class="th-ang__legal">Wir speichern deine Angaben zusammen mit diesem Angebot, damit wir es wiederfinden, wenn du dich meldest. Mehr dazu in der <a href="'+esc(cfg.datenschutz || '/policies/privacy-policy')+'" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>'
        +'<p class="th-ang__msg" id="th-ang-all" role="alert" hidden></p>'
        +'<div class="th-ang__actions"><button type="submit" class="th-ang__btn th-ang__btn--go" id="th-ang-go"></button><button type="button" class="th-ang__btn th-ang__btn--ghost" id="th-ang-cancel">Abbrechen</button></div>'
        +'</form>'
        +'<div class="th-ang__done" id="th-ang-done" tabindex="-1" role="status" hidden></div>'
        +'</div>';
      document.body.appendChild(win);
      win.addEventListener('mousedown', function(e){ if(e.target === win){ closeWin(); } });
      el('x').addEventListener('click', closeWin);
      el('cancel').addEventListener('click', closeWin);
      el('form').addEventListener('submit', onSubmit);
      win.addEventListener('keydown', function(e){
        if(e.key === 'Escape'){ e.preventDefault(); closeWin(); return; }
        if(e.key !== 'Tab'){ return; }
        var f = Array.prototype.filter.call(win.querySelectorAll('a[href],button:not([disabled]),input:not([tabindex="-1"])'), function(n){ return n.offsetParent !== null; });
        if(!f.length){ return; }
        var first = f[0], last = f[f.length-1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      });
      return win;
    }
    function setMsg(id, msg){
      var i = el(id), m = el(id+'-m'); if(!i || !m){ return; }
      if(msg){ i.setAttribute('aria-invalid','true'); m.textContent = msg; m.hidden = false; }
      else { i.removeAttribute('aria-invalid'); m.textContent = ''; m.hidden = true; }
    }
    function goLabel(){ return st.mode === 'email' ? 'Angebot zusenden' : 'Angebot als PDF erstellen'; }
    function openWin(mode, opener){
      ensureWin();
      st.mode = mode; st.opener = opener; st.t0 = Date.now(); st.id = uuid(); st.busy = false;
      var d = build({nr:'–'}); /* nur für Anzahl und Summe; gedruckt wird erst nach dem Absenden */
      el('t').textContent = mode === 'email' ? 'Angebot per E-Mail' : 'Angebot als PDF';
      el('rn').textContent = d.n + (d.n === 1 ? ' Position' : ' Positionen');
      el('rs').textContent = euro(d.brutto);
      var opt = win.querySelector('[data-opt-mail]'); if(opt){ opt.hidden = (mode === 'email'); }
      if(mode === 'email'){ el('mail').setAttribute('required',''); el('mail').setAttribute('aria-required','true'); }
      else { el('mail').removeAttribute('required'); el('mail').removeAttribute('aria-required'); }
      ['vor','nach','tel','mail'].forEach(function(id){ setMsg(id,''); });
      el('all').hidden = true;
      el('go').disabled = false; el('go').textContent = goLabel();
      el('form').hidden = false; el('done').hidden = true; el('done').innerHTML = '';
      win.querySelector('.th-ang__top').hidden = false; win.querySelector('.th-ang__recap').hidden = false;
      win.hidden = false;
      document.documentElement.classList.add('th-ang-open');
      var f = el('vor'); try{ f.focus({preventScroll:true}); }catch(e){ f.focus(); }
      track('angebot_fenster_offen', {art:mode});
    }
    function closeWin(){
      if(!win || win.hidden || st.busy){ return; }
      win.hidden = true;
      document.documentElement.classList.remove('th-ang-open');
      if(st.opener && st.opener.focus){ st.opener.focus(); }
      st.mode = null;
    }
    function validate(){
      var first = null, mode = st.mode;
      function chk(id, msg){ setMsg(id, msg); if(msg && !first){ first = el(id); } }
      var vor = el('vor').value.replace(/\s+/g,' ').trim(), nach = el('nach').value.replace(/\s+/g,' ').trim();
      var tel = el('tel').value.replace(/\s+/g,' ').trim(), mail = el('mail').value.trim();
      chk('vor', vor.length >= 2 ? '' : 'Bitte gib deinen Vornamen ein.');
      chk('nach', nach.length >= 2 ? '' : 'Bitte gib deinen Nachnamen ein.');
      var zif = tel.replace(/\D/g,'');
      chk('tel', (/^[+0-9 ()\/-]{6,25}$/.test(tel) && zif.length >= 6 && zif.length <= 15) ? '' : (zif.length < 6 ? 'Bitte gib eine Telefonnummer mit mindestens 6 Ziffern ein.' : 'Bitte nur Ziffern, Leerzeichen und + ( ) / - verwenden.'));
      var mailOk = /^[^\s@]{1,64}@[^\s@]{1,190}\.[A-Za-z]{2,24}$/.test(mail);
      chk('mail', ((!mail && mode !== 'email') || mailOk) ? '' : (mail ? 'Diese E-Mail-Adresse sieht nicht vollständig aus.' : 'Für den Versand brauchen wir deine E-Mail-Adresse.'));
      if(first){ first.focus(); return null; }
      return {vor:vor, nach:nach, tel:tel, mail:mailOk ? mail : '', anruf:el('anruf').checked};
    }
    /* Abschluss-Ansicht. p = {nr, mode, vor, mailto}; state:
       'senden'  Formular wird gleich normal abgesendet (Seite lädt neu)
       'warten'  PDF-Dialog offen (Handy), Senden nach dem Schließen oder per Knopf
       'ok'      Shopify hat die Nachricht angenommen (contact_posted=true)
       'fehler'  nicht angekommen: Anruf oder E-Mail-Programm */
    function showDone(p, state){
      ensureWin();
      var mode = p.mode;
      win.hidden = false; document.documentElement.classList.add('th-ang-open');
      var h = '<p class="th-ang__kick">'+(state === 'ok' ? 'Angebot angekommen' : 'Angebot erstellt')+'</p><div class="th-ang__nr">'+esc(p.nr)+'</div>';
      h += '<p><b>'+esc(p.vor)+', das ist deine Angebotsnummer.</b> Nenn sie uns am Telefon, dann haben wir alles sofort vor uns: <a class="th-ang__tel" href="tel:'+esc(String(cfg.shop.tel).replace(/[^+0-9]/g,''))+'">'+esc(cfg.shop.tel)+'</a>.</p>';
      if(state === 'senden' || state === 'warten'){
        h += '<p role="status">'+(state === 'warten' ? 'Wenn du mit dem PDF fertig bist, schicken wir das Angebot an uns.' : 'Wir schicken das Angebot jetzt an uns. Falls Shopify kurz prüft, ob du kein Roboter bist, bestätige das bitte.')+'</p>';
        if(state === 'warten'){ h += '<div class="th-ang__actions"><button type="button" class="th-ang__btn th-ang__btn--go" id="th-ang-send">Angebot an uns senden</button></div>'; }
      } else if(state === 'ok'){
        h += mode === 'email'
          ? '<p>Dein Angebot liegt uns vor. Wir schicken es dir per E-Mail, in der Regel noch am selben Werktag.</p>'
          : '<p>Dein Angebot liegt uns damit auch vor.</p>';
      } else {
        h += '<p class="th-ang__warn">Bei uns ist es gerade nicht angekommen. Dein Angebot gilt trotzdem. Ruf uns bitte kurz an und nenn die Nummer, oder schick es mit deinem E-Mail-Programm.</p>';
        if(p.mailto){ h += '<p><a class="th-ang__tel" style="white-space:normal;overflow-wrap:anywhere" href="'+esc(p.mailto)+'">Angebot mit deinem E-Mail-Programm an uns senden</a></p>'; }
      }
      if(state !== 'senden' && state !== 'warten'){
        h += '<div class="th-ang__actions">'+(p.html ? '<button type="button" class="th-ang__btn th-ang__btn--line" id="th-ang-print">'+(mode === 'email' ? 'Angebot drucken' : 'Noch einmal drucken')+'</button>' : '')+'<button type="button" class="th-ang__btn th-ang__btn--ghost" id="th-ang-close">Schließen</button></div>';
      }
      var box = el('done');
      box.innerHTML = h;
      el('form').hidden = true; win.querySelector('.th-ang__top').hidden = true; win.querySelector('.th-ang__recap').hidden = true;
      box.hidden = false;
      st.busy = (state === 'senden');
      if(el('print')){ el('print').addEventListener('click', function(){ if(p.html && out.innerHTML === ''){ out.innerHTML = p.html; if(out.parentNode !== document.body){ document.body.appendChild(out); } } window.print(); }); }
      if(el('close')){ el('close').addEventListener('click', function(){ st.busy = false; closeWin(); }); }
      try{ box.focus({preventScroll:true}); }catch(e){ box.focus(); }
    }
    function mailtoOf(d, k){
      var mt = String(cfg.shop.mail || 'hello@trailer-hunter.com');
      var mb = summary(d, k, 'Gesendet über das E-Mail-Programm des Kunden.');
      if(mb.length > 1800){ mb = mb.slice(0, 1800) + '\n…'; }
      return 'mailto:'+mt+'?subject='+encodeURIComponent('Angebot '+d.nr)+'&body='+encodeURIComponent(mb);
    }
    function onSubmit(ev){
      ev.preventDefault();
      if(st.busy){ return; }
      var k = validate(); if(!k){ return; }
      var mode = st.mode, g = collect(), pos = [], montage = false;
      [g.anh, g.ausf, g.zub, g.service].forEach(function(list, gi){
        list.forEach(function(it){
          var v = String(it.v == null ? '' : it.v).trim();
          if(/^[0-9]{6,20}$/.test(v)){ pos.push({variant_id:v, menge:Math.min(20, it.q||1)}); }
          else if(gi === 3){ montage = true; }
        });
      });
      st.busy = true; el('all').hidden = true;
      el('go').disabled = true; el('go').textContent = 'Wird erstellt …';
      askServer({ art:mode, vorname:k.vor, nachname:k.nach, telefon:k.tel, email:k.mail, datenschutz_ok:true, anruf_ok:k.anruf,
                  positionen:pos, montage:montage, anfrage_id:st.id, offen_ms:Date.now()-st.t0, website:el('website').value, seite:cfg.seite || '' })
        .then(function(a){
          if(a.weg === 'eingabe' || a.weg === 'artikel'){
            st.busy = false; el('go').disabled = false; el('go').textContent = goLabel();
            var id = a.weg === 'eingabe' ? FELD[a.feld] : null;
            if(id){ setMsg(id, a.meldung || 'Bitte prüfe diese Angabe.'); el(id).focus(); }
            else { var m = el('all'); m.textContent = a.weg === 'artikel' ? 'Ein Artikel ist nicht mehr verfügbar. Bitte lade die Seite neu und stell das Angebot noch einmal zusammen.' : 'Das hat nicht geklappt. Bitte prüfe deine Angaben oder ruf uns an: ' + cfg.shop.tel; m.hidden = false; }
            return;
          }
          var entwurf = a.weg === 'server';
          var d = build({ nr: entwurf ? a.j.angebotsnummer : ownNr(), kunde:k, server: entwurf ? a.j : null });
          /* Jedes Angebot geht an uns (auch das PDF). Ausnahme: das versteckte Feld „Website“
             ist gefüllt – dann war es ein Roboter, es wird nichts gesendet. */
          var bot = !!(el('website') && el('website').value);
          var extra = (mode === 'email' ? 'Kunde wünscht das Angebot per E-Mail.' : 'Kunde hat das PDF selbst erstellt.') + (entwurf ? ' Entwurf im Shop: ' + d.nr : ' Quelle: Angebots-Fenster im Shop.');
          var p = { nr:d.nr, mode:mode, vor:k.vor, mailto:mailtoOf(d, k), html:out.innerHTML, seite:location.pathname, t:Date.now() };
          track('angebot_erstellt', {art:mode, wert:Math.round(d.brutto)/100, value:Math.round(d.brutto)/100, currency:'EUR', nummer:d.nr, mit_entwurf:entwurf ? 'ja' : 'nein'});
          if(bot){ showDone(p, 'ok'); if(mode !== 'email'){ setTimeout(function(){ window.print(); }, 350); } return; }
          var bereit = fillForm(d, k, extra, mode);
          if(!bereit){ showDone(p, 'fehler'); if(mode !== 'email'){ setTimeout(function(){ window.print(); }, 350); } return; }
          merke(p);
          var los = function(){ if(los.done){ return; } los.done = true; showDone(p, 'senden'); if(!absenden()){ vergiss(); showDone(p, 'fehler'); } };
          if(mode === 'email'){ los(); return; }
          /* PDF zuerst: Druck-Dialog sofort. Am PC blockiert print() bis der Dialog zu ist,
             dann wird gesendet. Am Handy kehrt print() sofort zurück: dann erst nach
             „afterprint“ senden oder per Knopf, damit der PDF-Dialog nicht abbricht. */
          showDone(p, 'warten');
          if(el('send')){ el('send').addEventListener('click', los); }
          window.addEventListener('afterprint', function(){ setTimeout(los, 200); }, {once:true});
          setTimeout(function(){
            var t0 = Date.now();
            try{ window.print(); }catch(e){}
            if(Date.now() - t0 > 800){ setTimeout(los, 200); }
          }, 350);
        });
    }
    /* Rückkehr nach dem Absenden: Shopify lädt die Seite mit contact_posted=true
       (Erfolg) oder mit Fehlern im Formular. Nur dann zeigen wir etwas an. */
    function rueckkehr(){
      var p = gemerkt(); if(!p){ return; }
      var frisch = (Date.now() - (p.t || 0)) < 45 * 60 * 1000;
      if(!frisch || (p.seite !== location.pathname && !ctState)){ vergiss(); return; }
      var ok = ctState === 'ok' || /[?&]contact_posted=true/.test(location.search);
      if(ok){
        vergiss();
        if(p.html){ out.innerHTML = p.html; if(out.parentNode !== document.body){ document.body.appendChild(out); } }
        showDone(p, 'ok');
        track('angebot_angekommen', {art:p.mode, nummer:p.nr});
        try{ var u = new URL(location.href); u.searchParams.delete('contact_posted'); history.replaceState(history.state, '', u.pathname + (u.search || '') + u.hash.replace(/^#th-ang-contact$/, '')); }catch(e){}
      } else if(ctState === 'fehler'){
        vergiss();
        if(p.html){ out.innerHTML = p.html; if(out.parentNode !== document.body){ document.body.appendChild(out); } }
        showDone(p, 'fehler');
        track('angebot_nicht_angekommen', {art:p.mode, nummer:p.nr});
      }
    }

    btn.setAttribute('aria-haspopup','dialog');
    if(mailBtn){ mailBtn.setAttribute('aria-haspopup','dialog'); mailBtn.removeAttribute('aria-expanded'); }
    var altBox = root.querySelector('[data-th-mail-box]'); if(altBox){ altBox.hidden = true; }
    /* Die Section hat noch die alten Klick-Wege (sofort drucken, Felder aufklappen).
       Dieser Abfänger sitzt eine Ebene höher und läuft zuerst (Capture):
       Der Klick kommt bei den alten Wegen nicht mehr an, es öffnet sich nur das Fenster. */
    root.addEventListener('click', function(e){
      var t = (e.target && e.target.closest) ? e.target.closest('[data-th-angebot-btn],[data-th-mail-btn]') : null;
      if(!t || !root.contains(t)){ return; }
      e.preventDefault(); e.stopPropagation();
      openWin(t === mailBtn ? 'email' : 'pdf', t);
    }, true);
    rueckkehr();
})();